import api from 'api'

export type LinkIndeedFlexPositionParams = {
  ifClientId: number
  ifRoleId: number
  companyPositionId: number
}

export type LinkIndeedFlexPositionResponse = {
  id: number
}

export const linkIndeedFlexPosition = async (
  params: LinkIndeedFlexPositionParams
): Promise<LinkIndeedFlexPositionResponse> => {
  const result = await api.post<LinkIndeedFlexPositionResponse>(
    '/admin/indeed_flex/positions/link',
    params
  )
  return result.data
}
